import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private _params: { [s: string]: string; } = {};
  constructor() { }
  SetParams(data: object) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this._params[key] = data[key];
      }
    }
  }
}

